import React, { useState, useEffect } from 'react';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import apiRequest from "@/services/requests";

const PersonalInfoStep = ({ formData, onChange, errors,countries }) => {

const countryOptions = countries.map(country => ({
  value: country.name,
  label: country.name
}));

const genderOptions = [
{ value: 'male', label: 'Male' },
{ value: 'female', label: 'Female' },
]




const handleInputChange = (field, value) => {
onChange({ ...formData, [field]: value });
};

return (
<div className="space-y-6">
<div className="step-form-section">
<div className="mb-4">
<h2 className="step-form-section-title">Personal Information</h2>
<p className="step-description">Tell us more about yourself</p>
</div>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
<Select
label="Gender"
placeholder="Select your gender"
options={genderOptions}
value={formData?.gender || ''}
onChange={(value) => handleInputChange('gender', value)}
error={errors?.gender}
required
/>

<Input
label="Date of birth"
type="date"
placeholder="Enter your date of birth"
value={formData?.dob || ''}
onChange={(e) => handleInputChange('dob', e?.target?.value)}
error={errors?.dob}
required
/>
</div>


<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
<Select
label="Country of residence"
placeholder="Select your country"
options={countryOptions}
value={formData?.country || ''}
onChange={(value) => handleInputChange('country', value)}
error={errors?.country}
required
searchable
/>

<Input
label="City of residence"
type="text"
placeholder="Enter your city"
value={formData?.city || ''}
onChange={(e) => handleInputChange('city', e?.target?.value)}
error={errors?.city}
required
/>
</div>


</div>
</div>
);
};

export default PersonalInfoStep;